import React from 'react';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../../components/block/Block';
import Button from '../../../../components/button/Button';
import Icon from '../../../../components/icon/Icon';
import {Card, CardBody, Col, Form, Row} from 'reactstrap';
import TargetGroupsForm from './TargetGroupsForm';
import {useNavigate} from 'react-router-dom';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {ITargetGroups} from '../interfaces/ITargetGroups';
import {targetGroupsFormSchema} from './TargetGroupsUpdate';
import {targetGroupsApi} from '../../../../api';
import {useTranslation} from 'react-i18next';

const TargetGroupsCreate = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const methods = useForm<ITargetGroups>({
    resolver: yupResolver(targetGroupsFormSchema),
  });

  const onFormSubmit = async (formData: ITargetGroups) => {
    const {data} = await targetGroupsApi.createTargetGroups(formData);
    if (data) {
      navigate('/app/admin/target-groups');
    }
  };
  return (
    <Block size="lg" className="mt-3">
      <BlockHead>
        <BlockHeadContent>
          <div className="row align-items-center gx-0 gx-lg-2">
            <div className="col-md-10 col-12">
              <BlockTitle tag="h4">{t('administrator.targetGroups.targetGroupsCreate')}</BlockTitle>
            </div>
            <div className="col-md-2 col-12 text-end">
              <Button
                className="btn-block"
                color="secondary"
                onClick={() => {
                  navigate('/app/admin/target-groups');
                }}
              >
                <Icon name="arrow-long-left" />
                {t('general.back')}
              </Button>
            </div>
          </div>
        </BlockHeadContent>
      </BlockHead>
      <Card className="card-bordered card-preview">
        <CardBody>
          <FormProvider {...methods}>
            <Form onSubmit={methods?.handleSubmit(onFormSubmit)} className="py-3">
              <TargetGroupsForm register={methods?.register} errors={methods?.formState?.errors} />
              <Row>
                <Col>
                  <Row>
                    <Col className={'text-end'}>
                      <Button color="primary">
                        <Icon name="plus-sm" />
                        {t('general.create')}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </FormProvider>
        </CardBody>
      </Card>
    </Block>
  );
};

export default TargetGroupsCreate;
